import styled, { css } from 'styled-components';
import { variants, th } from 'style/theme';
import { FaExclamationTriangle, FaTimes, FaCheck } from 'react-icons/fa';
import { P, H6 } from 'components/Typography';

export const AlertContainer = styled.div`
  ${variants('variant', {
    danger: css`
      background-color: #fbe2e1;
      color: #c23030;
    `,
    warning: css`
      background-color: #f6e1cb;
      color: #bf7326;
    `,
    success: css`
      background-color: #e0efe7;
      color: #0f8050;
    `
  })};

  position: relative;
  border-radius: 5px;
  padding: 12px;
`;

export const AlertContent = styled.div`
  color: ${th('colors.black')};
  line-height: 1.4;
`;

export const AlertLabel = styled(H6)`
  font-size: 17px;
  line-height: 18px;
  margin-bottom: 6px;
`;

export const CloseIcon = styled(FaTimes)`
  ${variants('variant', {
    danger: css`
      color: #c23030;
    `,
    warning: css`
      color: #bf7326;
    `,
    success: css`
      color: #0f8050;
    `
  })};

  position: absolute;
  top: 9px;
  right: 12px;
  cursor: pointer;
`;

export const ExclamationIcon = styled(FaExclamationTriangle)`
  position: relative;
  font-size: 13px;
  bottom: 1px;
  margin-right: 4px;
`;

export const Checkmark = styled(FaCheck)`
  position: relative;
  font-size: 13px;
  margin-right: 6px;
`;
